import React from "react";
import "../css/HeaderSub.css";
import Popover from "@material-ui/core/Popover";

import { IconButton } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import Signout from "./Signout";
import SettingsIcon from "@material-ui/icons/Settings";

import { Link } from "react-router-dom";

function HeaderSub() {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <div className="headerSub">
      <IconButton onClick={handleClick}>
        <ArrowDropDownIcon />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div className="headerSub__popOver">
          <ul>
            {/* <li>
              <p>
                <Link to="/setting/">
                  <SettingsIcon /> Setting
                </Link>
              </p>
            </li> */}
            <li>
              <Signout />
            </li>
          </ul>
        </div>
      </Popover>
    </div>
  );
}

export default HeaderSub;
